import apiService from './api.service';

class HotNewsService {
  async getHotNewsByUid(uid) {
    try {
      const response = await apiService.post('/sections/get-by-uid', {UID: uid}, {}, true);
      if (response && response.code === 1 && response.data) {
        const hotNewsData = Array.isArray(response.data) ? response.data[0] : response.data;
        
        // Filter out unpublished content
        if (hotNewsData && hotNewsData.IsPublished === false) {
          return {
            success: false,
            data: null,
            message: 'Hot news is not published',
          };
        }
        
        return {
          success: true,
          data: hotNewsData,
          message: response.message,
        };
      }
      
      return {
        success: false,
        data: null,
        message: response?.message || 'Failed to fetch hot news content',
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.message || 'An error occurred while fetching hot news content',
      };
    }
  }

  async getHotNews() {
    return this.getHotNewsByUid('HOT-NEWS');
  }

  transformHotNewsData(apiData) {
    const transformed = {
      id: apiData.SectionId || apiData.Id || apiData.id,
      title: apiData.Title || apiData.title,
      subtitle: apiData.SubTitle || apiData.subtitle,
      content: apiData.Description || apiData.description || apiData.Content,
      link: apiData.Link || apiData.link,
      imageUrl: apiData.ImageUrl || apiData.imageUrl,
      publishedAt: apiData.PublishedAt || apiData.publishedAt || apiData.CreatedAt || apiData.createdAt || null,
    };
    
    return transformed;
  }
}

export default new HotNewsService();
